/**
 * Soffisticata Size Guide Widget v2.0
 * Guia de tamanho inteligente — roupas + calçados, com preferência de caimento
 */
(function (window, document) {
  'use strict';

  // ─── TABELAS ─────────────────────────────────────────────────────────────
  const TABELA_TOPS = {
    'PP':  { h: [150, 168], w: [48,  67]  },
    'P':   { h: [163, 173], w: [63,  78]  },
    'M':   { h: [168, 179], w: [74,  90]  },
    'G':   { h: [173, 183], w: [85, 102]  },
    'GG':  { h: [177, 187], w: [97, 116]  },
    'XG':  { h: [181, 191], w: [110, 132] },
    '2XG': { h: [184, 194], w: [126, 150] },
    '3XG': { h: [186, 198], w: [144, 170] },
    '4XG': { h: [188, 215], w: [162, 230] },
  };

  const TABELA_BOTTOMS = {
    'PP':  { h: [150, 168], w: [48,  65]  },
    'P':   { h: [163, 173], w: [62,  77]  },
    'M':   { h: [168, 179], w: [73,  88]  },
    'G':   { h: [173, 183], w: [84, 100]  },
    'GG':  { h: [177, 187], w: [96, 114]  },
    'XG':  { h: [181, 191], w: [108, 130] },
    '2XG': { h: [184, 194], w: [124, 148] },
    '3XG': { h: [186, 198], w: [142, 168] },
    '4XG': { h: [188, 215], w: [160, 230] },
  };

  // Comprimento do pé em mm → numeração BR
  const TABELA_SHOES = {
    '36': [228, 235],
    '37': [236, 242],
    '38': [243, 249],
    '39': [250, 256],
    '40': [257, 263],
    '41': [264, 270],
    '42': [271, 277],
    '43': [278, 284],
    '44': [285, 292],
    '45': [293, 304],
  };

  // ─── SVG ICONS ──────────────────────────────────────────────────────────
  const ICON_RULER = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="8" width="22" height="8" rx="1"/><line x1="5" y1="8" x2="5" y2="13"/><line x1="9" y1="8" x2="9" y2="11"/><line x1="13" y1="8" x2="13" y2="13"/><line x1="17" y1="8" x2="17" y2="11"/><line x1="21" y1="8" x2="21" y2="13"/></svg>`;

  const ICON_TOP = `<svg width="36" height="36" viewBox="0 0 512 512" fill="#4B3621" xmlns="http://www.w3.org/2000/svg"><path d="M256,96c33.08,0,60.71-25.78,64-58,.3-3-3-6-6-6h0a13,13,0,0,0-4.74.9c-.2.08-21.1,8.1-53.26,8.1s-53.1-8-53.26-8.1a16.21,16.21,0,0,0-5.3-.9h-.06A5.69,5.69,0,0,0,192,38C195.35,70.16,223,96,256,96Z"/><path d="M485.29,89.9,356,44.64a4,4,0,0,0-5.27,3.16,96,96,0,0,1-189.38,0A4,4,0,0,0,156,44.64L26.71,89.9A16,16,0,0,0,16.28,108l16.63,88A16,16,0,0,0,46.83,208.9l48.88,5.52a8,8,0,0,1,7.1,8.19l-7.33,240.9a16,16,0,0,0,9.1,14.94A17.49,17.49,0,0,0,112,480H400a17.49,17.49,0,0,0,7.42-1.55,16,16,0,0,0,9.1-14.94l-7.33-240.9a8,8,0,0,1,7.1-8.19l48.88-5.52A16,16,0,0,0,479.09,196l16.63-88A16,16,0,0,0,485.29,89.9Z"/></svg>`;

  const ICON_BOTTOM = `<svg width="36" height="36" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path fill="#4B3621" d="M406.997,51.615H105.002c-2.568,0-4.648,2.08-4.648,4.648V507.36c0,2.56,2.08,4.64,4.648,4.64h117.086c2.416,0,4.424-1.84,4.632-4.248l24.655-287.267c0.201-2.4,2.216-4.248,4.624-4.248c2.408,0,4.424,1.848,4.623,4.248l24.656,287.267c0.208,2.408,2.216,4.248,4.632,4.248h117.086c2.568,0,4.648-2.08,4.648-4.64V56.263C411.646,53.695,409.566,51.615,406.997,51.615z"/><rect fill="#4B3621" x="225.28" width="61.439" height="40.144"/><rect fill="#4B3621" x="100.354" width="107.718" height="40.144"/><rect fill="#4B3621" x="302.287" width="109.358" height="40.144"/></svg>`;

  const ICON_SHOE = `<svg width="36" height="36" viewBox="0 0 61.194 61.193" fill="#4B3621" xmlns="http://www.w3.org/2000/svg"><path d="M3,36.938c-0.375,0-1.613-0.113-2.637-1.32c-0.158,2.699,1.607,5.03,4.022,5.243l11.607,1.022c1.472,0.13,2.838-0.566,3.76-1.729c-2.431-1.015-6.766-2.071-16.748-3.216H3z"/><path d="M13.37,22.264c0.264,0,0.524-0.01,0.782-0.028l1.596-0.245c0.094-0.022,0.186-0.053,0.28-0.078c-3.552-1.226-10.708-3.607-12.964-3.71l0.069,0.059C3.183,18.3,7.946,22.264,13.37,22.264z"/><path d="M3,35.896c0.034,0,0.053-0.001,0.053-0.001c10.396,1.188,14.783,2.285,17.277,3.364c3.881,1.681,3.161,3.318,13.261,5.197c2.438,0.453,4.752,0.646,6.931,0.646c12.655,0,20.673-6.52,20.673-6.52c-0.294-2.496-3.523-4.259-11.599-7.004c-3.894-1.324-8.295-4.042-11.812-6.502v7.486l-0.513,0.009c0,0-0.274,0.005-0.7,0.005c-2.491,0-4.04-0.139-4.603-0.413c-0.385-0.188-0.905-0.439-0.589-6.194c-1.044,0.791-1.962,1.19-2.733,1.19c-0.561,0-1.333-0.213-1.834-1.227c-0.444-0.9-0.399-1.845,0.131-2.733c0.865-1.448,2.938-2.53,4.644-2.829c-0.22-0.182-0.343-0.288-0.343-0.288s-1.234-1.796-4.088-1.796c-1.76,0-4.136,0.684-7.217,2.896c-0.335,0.24-0.671,0.45-1.009,0.643c-0.995,0.573-2.002,0.958-3.003,1.19c-0.542,0.125-1.081,0.205-1.617,0.247c-0.314,0.025-0.628,0.041-0.938,0.041c-0.624,0-1.235-0.056-1.835-0.143c-0.516-0.074-1.022-0.171-1.513-0.295c-3.738-0.937-6.663-3.105-7.378-3.669c-0.11-0.086-0.18-0.145-0.18-0.145c-0.139,0.411-0.266,0.805-0.392,1.195c-0.158,0.493-0.306,0.971-0.444,1.434c-2.009,6.744-1.865,10.291-1.124,12.152C1.281,35.789,2.71,35.896,3,35.896z"/><path d="M32.508,31.26c0.408,0.133,1.667,0.274,4.062,0.274c0.062,0,0.118,0,0.171,0v-7.195V23.69v-0.645v-0.567l-0.907-0.667l0.075-0.333c0.094-0.41,0.148-0.748,0.171-1.064c0.079-1.025-0.496-2.988-1.33-3.888c-0.523-0.566-0.977-0.582-1.524-0.037c-0.922,0.922-0.903,2.231-0.627,3.366c0.065,0.271,0.141,0.537,0.229,0.781l0.035,0.103l0.202,0.566l-0.316,0.012l-0.396,0.013c-1.486,0.053-3.734,1.093-4.518,2.405c-0.351,0.586-0.379,1.155-0.092,1.737c0.282,0.574,0.629,0.646,0.9,0.646c0.708,0,1.765-0.607,2.975-1.708l0.957-0.87l-0.086,1.29C32.159,29.842,32.417,31.014,32.508,31.26z"/></svg>`;



  // ─── CSS ─────────────────────────────────────────────────────────────────
  const CSS = `
    #soff-size-btn {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      background: none;
      border: none;
      color: #9A7B4F;
      padding: 2px 0 6px;
      font-size: 12px;
      font-family: inherit;
      letter-spacing: 0.07em;
      cursor: pointer;
      text-transform: uppercase;
      text-decoration: underline;
      text-underline-offset: 3px;
      text-decoration-color: rgba(154,123,79,0.4);
      transition: color 0.2s, text-decoration-color 0.2s;
      vertical-align: middle;
      margin-left: 10px;
      position: relative;
      top: -1px;
    }
    #soff-size-btn:hover {
      color: #4B3621;
      text-decoration-color: rgba(44,26,14,0.4);
    }

    #soff-overlay {
      display: none;
      position: fixed;
      inset: 0;
      background: rgba(20,12,6,0.6);
      z-index: 99998;
      backdrop-filter: blur(2px);
    }
    #soff-overlay.open {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      animation: soffFadeIn 0.2s ease;
    }

    #soff-modal {
      background: #fff;
      width: 100%;
      max-width: 420px;
      padding: 36px 32px 28px;
      position: relative;
      box-shadow: 0 24px 64px rgba(0,0,0,0.16);
      animation: soffSlideUp 0.25s ease;
    }

    #soff-modal-close {
      position: absolute;
      top: 16px; right: 18px;
      background: none; border: none;
      font-size: 20px; cursor: pointer;
      color: #bbb; line-height: 1; padding: 4px;
      transition: color 0.15s;
    }
    #soff-modal-close:hover { color: #4B3621; }

    .soff-logo {
      margin-bottom: 12px;
      text-align: center;
    }
    .soff-logo img, .soff-logo svg {
      width: auto;
      max-width: 140px;
      margin: 0 auto;
      height: 28px;
      object-fit: contain;
      display: block;
    }
    .soff-brand-text {
      font-size: 9px;
      letter-spacing: 0.25em;
      color: #C4A35A;
      text-transform: uppercase;
      font-weight: 500;
    }
    .soff-title {
      font-size: 22px;
      color: #4B3621;
      font-weight: 600;
      margin-bottom: 8px;
      letter-spacing: 0.01em;
      text-align: center;
    }
    .soff-subtitle {
      font-size: 12px;
      color: #AAA;
      margin-bottom: 16px;
      letter-spacing: 0.01em;
      line-height: 1.4;
      text-align: center;
    }

    .soff-progress {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      margin-bottom: 20px;
    }
    .soff-progress::before {
      content: '';
      position: absolute;
      top: 50%; left: 13px; right: 13px;
      transform: translateY(-50%);
      height: 1px;
      background: #EDE8E2;
      z-index: 0;
    }
    .soff-progress-dot {
      width: 26px !important; height: 26px !important;
      min-width: 26px !important; min-height: 26px !important;
      border-radius: 50% !important;
      background: #fff !important;
      border: 1.5px solid #DDD8D0 !important;
      flex-shrink: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      position: relative;
      z-index: 1;
      box-sizing: border-box !important;
      font-size: 10px !important;
      font-weight: 600 !important;
      color: #C8C0B5 !important;
      font-family: inherit !important;
      transition: all 0.3s;
    }
    .soff-progress-dot.done   { background: #C4A35A !important; border-color: #C4A35A !important; color: #fff !important; }
    .soff-progress-dot.active { background: #4B3621 !important; border-color: #4B3621 !important; color: #fff !important; }

    .soff-step { display: none; }
    .soff-step.active { display: block; }

    .soff-step-label {
      font-size: 13px;
      color: #666;
      margin-bottom: 16px;
      letter-spacing: 0.02em;
    }

    /* ── Tipo cards (3 em linha) ── */
    .soff-type-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
    }
    .soff-type-card {
      border: 1.5px solid #DDD8D0;
      padding: 18px 8px 14px;
      cursor: pointer;
      text-align: center;
      transition: all 0.15s;
      background: none;
      font-family: inherit;
    }
    .soff-type-card:hover { border-color: #4B3621; background: #FAF8F5; }
    .soff-type-card.selected { border-color: #4B3621; background: #FAF8F5; }
    .soff-type-card svg { display: block; margin: 0 auto 8px; }
    .soff-type-label {
      font-size: 9px;
      color: #4B3621;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      font-weight: 500;
    }

    /* ── Fit preference ── */
    .soff-fit-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 8px;
      margin-bottom: 4px;
    }
    .soff-fit-btn {
      border: 1.5px solid #DDD8D0;
      padding: 14px 6px 12px;
      cursor: pointer;
      text-align: center;
      background: none;
      font-family: inherit;
      transition: all 0.15s;
    }
    .soff-fit-btn:hover { border-color: #4B3621; background: #FAF8F5; }
    .soff-fit-btn.selected { border-color: #4B3621; background: #FAF8F5; }
    .soff-fit-icon {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      gap: 2px;
      height: 64px;
      margin-bottom: 8px;
      align-items: center;
    }
    .soff-fit-bar {
      background: #4B3621;
      border-radius: 1px;
      width: 6px;
    }
    .soff-fit-name {
      font-size: 10px;
      color: #4B3621;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      font-weight: 500;
      display: block;
      margin-bottom: 3px;
    }
    .soff-fit-desc {
      font-size: 9.5px;
      color: #999;
      letter-spacing: 0.02em;
      line-height: 1.3;
    }

    /* ── Sliders ── */
    .soff-slider-row {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      margin-bottom: 14px;
    }
    .soff-slider-row-label { font-size: 13px; color: #555; }
    .soff-slider-value {
      font-size: 32px;
      font-weight: 700;
      color: #4B3621;
      letter-spacing: -0.02em;
    }
    .soff-slider-unit { font-size: 13px; color: #AAA; margin-left: 2px; }

    .soff-slider {
      -webkit-appearance: none;
      width: 100%; height: 3px;
      background: #E8E2DA;
      outline: none; border-radius: 2px;
      margin: 4px 0;
    }
    .soff-slider::-webkit-slider-thumb {
      -webkit-appearance: none;
      width: 20px; height: 20px;
      border-radius: 50%;
      background: #4B3621;
      cursor: pointer;
      box-shadow: 0 2px 8px rgba(0,0,0,0.18);
    }
    .soff-slider::-moz-range-thumb {
      width: 20px; height: 20px;
      border-radius: 50%;
      background: #4B3621;
      cursor: pointer; border: none;
    }
    .soff-slider-limits {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
      color: #C0BAB2;
      margin-top: 4px;
    }

    /* ── Resultado ── */
    .soff-result-box {
      background: #FAF8F5;
      border: 1px solid #EDE8E2;
      padding: 22px 20px;
      text-align: center;
      margin: 4px 0 14px;
    }
    .soff-result-eyebrow {
      font-size: 9px;
      letter-spacing: 0.2em;
      color: #C4A35A;
      text-transform: uppercase;
      margin-bottom: 6px;
    }
    .soff-result-size {
      font-size: 60px;
      font-weight: 800;
      color: #4B3621;
      line-height: 1;
      letter-spacing: -0.03em;
    }
    .soff-result-sub {
      font-size: 11px;
      color: #999;
      margin-top: 6px;
      letter-spacing: 0.04em;
    }

    .soff-confidence {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 16px;
    }
    .soff-conf-label { font-size: 11px; color: #AAA; white-space: nowrap; }
    .soff-confidence-bar-wrap {
      flex: 1; height: 4px;
      background: #EDE8E2; border-radius: 2px; overflow: hidden;
    }
    .soff-confidence-bar {
      height: 100%;
      background: linear-gradient(90deg, #C4A35A, #4B3621);
      border-radius: 2px;
      transition: width 0.7s cubic-bezier(0.4,0,0.2,1);
    }
    .soff-confidence-pct {
      font-size: 12px; font-weight: 600;
      color: #4B3621; min-width: 34px; text-align: right;
    }

    .soff-result-tip {
      font-size: 12px; color: #888;
      line-height: 1.6; text-align: center;
      margin-bottom: 16px;
    }

    /* ── Shoe size result badge ── */
    .soff-shoe-range {
      font-size: 11px;
      color: #C4A35A;
      letter-spacing: 0.06em;
      margin-top: 4px;
    }

    /* ── Navegação ── */
    .soff-nav { display: flex; gap: 8px; margin-top: 22px; }

    .soff-btn-back {
      background: none;
      border: 1.5px solid #DDD8D0;
      color: #999; padding: 12px 18px;
      font-size: 12px; cursor: pointer;
      font-family: inherit; letter-spacing: 0.06em;
      text-transform: uppercase;
      transition: all 0.15s;
    }
    .soff-btn-back:hover { border-color: #4B3621; color: #4B3621; }

    .soff-btn-next, .soff-btn-apply {
      flex: 1;
      width: 100%;
      background: #4B3621; border: none;
      color: #fff; padding: 14px;
      font-size: 12px; font-family: inherit;
      letter-spacing: 0.1em; text-transform: uppercase;
      cursor: pointer; transition: background 0.15s;
    }
    .soff-btn-next:hover, .soff-btn-apply:hover { background: #C4A35A; }
    .soff-btn-next:disabled { background: #D5CFC7; cursor: not-allowed; }

    .soff-retry {
      display: block; width: 100%;
      background: none; border: none;
      color: #C4A35A; font-size: 12px;
      cursor: pointer; font-family: inherit;
      text-decoration: underline; text-underline-offset: 3px;
      margin-top: 10px; text-align: center;
      letter-spacing: 0.05em;
      transition: color 0.15s;
    }
    .soff-retry:hover { color: #4B3621; }

    .soff-toast {
      position: fixed; bottom: 24px; left: 50%;
      transform: translateX(-50%);
      background: #4B3621; color: #fff;
      padding: 12px 28px; font-size: 13px;
      z-index: 99999; letter-spacing: 0.06em;
      box-shadow: 0 4px 24px rgba(0,0,0,0.18);
      white-space: nowrap;
      animation: soffFadeIn 0.2s ease;
    }

    @keyframes soffFadeIn  { from { opacity: 0; } to { opacity: 1; } }
    @keyframes soffSlideUp { from { transform: translateY(16px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

    @media (max-width: 480px) {
      #soff-modal { padding: 28px 20px 22px; }
      .soff-result-size { font-size: 48px; }
      .soff-title { font-size: 19px; }
      .soff-type-label { font-size: 8px; }
    }
  `;

  // ─── HTML ────────────────────────────────────────────────────────────────
  function criarHTML() {
    return `
      <div id="soff-overlay" role="dialog" aria-modal="true" aria-label="Guia de tamanho Soffisticata">
        <div id="soff-modal">
          <button id="soff-modal-close" aria-label="Fechar">×</button>
          <div class="soff-logo" id="soff-logo-wrap"></div>
          <div class="soff-title">Encontre seu tamanho</div>
          <div class="soff-subtitle">Recomendação personalizada em 3 perguntas rápidas</div>

          <div class="soff-progress" id="soff-progress">
            <div class="soff-progress-dot active" id="soff-dot-1">1</div>
            <div class="soff-progress-dot" id="soff-dot-2">2</div>
            <div class="soff-progress-dot" id="soff-dot-3">3</div>
            <div class="soff-progress-dot" id="soff-dot-4">4</div>
          </div>

          <!-- Passo 1: Tipo -->
          <div class="soff-step active" id="soff-step-1">
            <p class="soff-step-label">O que você está comprando?</p>
            <div class="soff-type-grid">
              <button class="soff-type-card" data-type="top">
                ${ICON_TOP}
                <span class="soff-type-label">Parte de cima</span>
              </button>
              <button class="soff-type-card" data-type="bottom">
                ${ICON_BOTTOM}
                <span class="soff-type-label">Parte de baixo</span>
              </button>
              <button class="soff-type-card" data-type="shoe">
                ${ICON_SHOE}
                <span class="soff-type-label">Calçado</span>
              </button>
            </div>
            <div class="soff-nav">
              <button class="soff-btn-next" id="soff-btn-1" disabled>Continuar</button>
            </div>
          </div>

          <!-- Passo 2A: Caimento (tops/bottoms) -->
          <div class="soff-step" id="soff-step-2a">
            <p class="soff-step-label">Como você prefere o caimento?</p>
            <div class="soff-fit-grid">
              <button class="soff-fit-btn" data-fit="justa">
                <div class="soff-fit-icon">
                  <svg width="100%" height="60" viewBox="-2 -2 64 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22,4 Q30,10 38,4 L44,4 L54,16 L52,22 L42,18 L42,58 L18,58 L18,18 L8,22 L6,16 L16,4 Z" stroke="#4B3621" stroke-width="1.5" stroke-linejoin="round" fill="rgba(75,54,33,0.06)"/>
                  </svg>
                </div>
                <span class="soff-fit-name">Justa</span>
                <span class="soff-fit-desc">Slim fit, colada ao corpo</span>
              </button>
              <button class="soff-fit-btn selected" data-fit="regular">
                <div class="soff-fit-icon">
                  <svg width="100%" height="60" viewBox="-2 -2 64 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20,4 Q30,11 40,4 L47,4 L57,18 L53,24 L44,18 L44,58 L16,58 L16,18 L7,24 L3,18 L13,4 Z" stroke="#4B3621" stroke-width="1.5" stroke-linejoin="round" fill="rgba(75,54,33,0.06)"/>
                  </svg>
                </div>
                <span class="soff-fit-name">Regular</span>
                <span class="soff-fit-desc">Caimento clássico</span>
              </button>
              <button class="soff-fit-btn" data-fit="folgada">
                <div class="soff-fit-icon">
                  <svg width="100%" height="60" viewBox="-2 -2 64 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18,4 Q30,12 42,4 L50,4 L61,20 L55,26 L46,18 L46,60 L14,60 L14,18 L5,26 L-1,20 L10,4 Z" stroke="#4B3621" stroke-width="1.5" stroke-linejoin="round" fill="rgba(75,54,33,0.06)"/>
                  </svg>
                </div>
                <span class="soff-fit-name">Folgada</span>
                <span class="soff-fit-desc">Oversized, ampla</span>
              </button>
            </div>
            <div class="soff-nav">
              <button class="soff-btn-back" id="soff-back-2a">Voltar</button>
              <button class="soff-btn-next" id="soff-btn-2a">Continuar</button>
            </div>
          </div>

          <!-- Passo 2B: Calçado — comprimento do pé -->
          <div class="soff-step" id="soff-step-2b">
            <div class="soff-slider-row">
              <span class="soff-slider-row-label">Comprimento do pé</span>
              <div>
                <span class="soff-slider-value" id="soff-pe-val">26</span>
                <span class="soff-slider-unit">cm</span>
              </div>
            </div>
            <input type="range" class="soff-slider" id="soff-slider-pe" min="228" max="304" value="265" step="1">
            <div class="soff-slider-limits"><span>23 cm</span><span>30 cm</span></div>
            <p class="soff-result-tip" style="margin-top:14px;margin-bottom:0">
              Meça em cm com uma régua: do calcanhar até a ponta do dedão.
            </p>
            <div class="soff-nav">
              <button class="soff-btn-back" id="soff-back-2b">Voltar</button>
              <button class="soff-btn-next" id="soff-btn-2b">Ver meu número</button>
            </div>
          </div>

          <!-- Passo 3: Altura -->
          <div class="soff-step" id="soff-step-3">
            <div class="soff-slider-row">
              <span class="soff-slider-row-label">Sua altura</span>
              <div>
                <span class="soff-slider-value" id="soff-altura-val">175</span>
                <span class="soff-slider-unit">cm</span>
              </div>
            </div>
            <input type="range" class="soff-slider" id="soff-slider-altura" min="150" max="210" value="175" step="1">
            <div class="soff-slider-limits"><span>150 cm</span><span>210 cm</span></div>
            <div class="soff-nav">
              <button class="soff-btn-back" id="soff-back-3">Voltar</button>
              <button class="soff-btn-next" id="soff-btn-3">Continuar</button>
            </div>
          </div>

          <!-- Passo 4: Peso -->
          <div class="soff-step" id="soff-step-4">
            <div class="soff-slider-row">
              <span class="soff-slider-row-label">Seu peso</span>
              <div>
                <span class="soff-slider-value" id="soff-peso-val">80</span>
                <span class="soff-slider-unit">kg</span>
              </div>
            </div>
            <input type="range" class="soff-slider" id="soff-slider-peso" min="48" max="200" value="80" step="1">
            <div class="soff-slider-limits"><span>48 kg</span><span>200 kg</span></div>
            <div class="soff-nav">
              <button class="soff-btn-back" id="soff-back-4">Voltar</button>
              <button class="soff-btn-next" id="soff-btn-4">Ver meu tamanho</button>
            </div>
          </div>

          <!-- Resultado -->
          <div class="soff-step" id="soff-step-resultado">
            <div class="soff-result-box">
              <div class="soff-result-eyebrow" id="soff-result-eyebrow">Tamanho recomendado</div>
              <div class="soff-result-size" id="soff-result-size">M</div>
              <div class="soff-result-sub" id="soff-result-sub"></div>
              <div class="soff-shoe-range" id="soff-shoe-range" style="display:none"></div>
            </div>
            <div class="soff-confidence" id="soff-conf-wrap">
              <span class="soff-conf-label">Precisão</span>
              <div class="soff-confidence-bar-wrap">
                <div class="soff-confidence-bar" id="soff-conf-bar" style="width:0%"></div>
              </div>
              <span class="soff-confidence-pct" id="soff-conf-pct">—</span>
            </div>
            <p class="soff-result-tip" id="soff-result-tip"></p>
            <button class="soff-btn-apply" id="soff-btn-apply">Selecionar este tamanho</button>
            <button class="soff-retry" id="soff-retry">Refazer medidas</button>
          </div>

        </div>
      </div>
    `;
  }

  // ─── ALGORITMO — ROUPAS ──────────────────────────────────────────────────
  function recomendar(altura, peso, tipo, fit) {
    const tabela = tipo === 'bottom' ? TABELA_BOTTOMS : TABELA_TOPS;
    // Ajuste de caimento: desloca o peso efetivo
    const bias = fit === 'justa' ? -7 : fit === 'folgada' ? 8 : 0;
    const pesoBias = peso + bias;
    let melhorTamanho = 'M', melhorScore = -Infinity;
    Object.entries(tabela).forEach(([tamanho, range]) => {
      const hMid = (range.h[0] + range.h[1]) / 2;
      const wMid = (range.w[0] + range.w[1]) / 2;
      const hRange = Math.max(range.h[1] - range.h[0], 1);
      const wRange = Math.max(range.w[1] - range.w[0], 1);
      const hScore = Math.exp(-0.5 * Math.pow((altura - hMid) / (hRange / 2.2), 2));
      const wScore = Math.exp(-0.5 * Math.pow((pesoBias - wMid) / (wRange / 2.2), 2));
      const score = hScore * 0.35 + wScore * 0.65;
      if (score > melhorScore) { melhorScore = score; melhorTamanho = tamanho; }
    });
    return { tamanho: melhorTamanho, confianca: Math.round(Math.max(72, Math.min(97, melhorScore * 125))) };
  }

  // ─── ALGORITMO — CALÇADO ────────────────────────────────────────────────
  function recomendarCalcado(pe_mm) {
    let melhorNum = '41', melhorDist = Infinity;
    Object.entries(TABELA_SHOES).forEach(([num, [min, max]]) => {
      const mid = (min + max) / 2;
      const dist = Math.abs(pe_mm - mid);
      if (dist < melhorDist) { melhorDist = dist; melhorNum = num; }
    });
    const range = TABELA_SHOES[melhorNum];
    const pe_cm = (pe_mm / 10).toFixed(1);
    return { numero: melhorNum, range_mm: range, pe_cm };
  }

  // ─── ESTADO ──────────────────────────────────────────────────────────────
  let estado = { tipo: null, fit: 'regular', altura: 175, peso: 80, pe: 265, resultado: null };

  // ─── NAVEGAÇÃO ──────────────────────────────────────────────────────────
  function mostrarStep(id) {
    document.querySelectorAll('.soff-step').forEach(el => el.classList.remove('active'));
    document.getElementById('soff-step-' + id).classList.add('active');
    atualizarDots(id);
  }

  function atualizarDots(stepId) {
    const eCalcado = estado.tipo === 'shoe';
    // Mapeia step → índice do dot (1-based)
    let dotAtivo;
    if (eCalcado) {
      // 3 dots: tipo=1, pe=2, resultado=3
      const map = { '1': 1, '2b': 2, 'resultado': 3 };
      dotAtivo = map[stepId] || 1;
      // Mostra 3 dots
      document.getElementById('soff-dot-4').style.display = 'none';
    } else {
      // 4 dots: tipo=1, fit=2, altura=3, peso+resultado=4
      const map = { '1': 1, '2a': 2, '3': 3, '4': 4, 'resultado': 4 };
      dotAtivo = map[stepId] || 1;
      document.getElementById('soff-dot-4').style.display = '';
    }
    [1, 2, 3, 4].forEach(i => {
      const d = document.getElementById('soff-dot-' + i);
      if (!d) return;
      d.className = 'soff-progress-dot' + (i < dotAtivo ? ' done' : i === dotAtivo ? ' active' : '');
    });
  }

  // ─── CALCULAR E MOSTRAR RESULTADO ────────────────────────────────────────
  function calcTamanho() {
    const isShoe = estado.tipo === 'shoe';
    const confWrap = document.getElementById('soff-conf-wrap');
    const shoeRange = document.getElementById('soff-shoe-range');

    if (isShoe) {
      const res = recomendarCalcado(estado.pe);
      estado.resultado = res.numero;
      document.getElementById('soff-result-eyebrow').textContent = 'Numeração recomendada';
      document.getElementById('soff-result-size').textContent = res.numero;
      document.getElementById('soff-result-sub').textContent = 'numeração brasileira';
      shoeRange.style.display = 'block';
      shoeRange.textContent = 'pé de ' + res.pe_cm + ' cm · comprimento ' + res.range_mm[0] + '–' + res.range_mm[1] + ' mm';
      confWrap.style.display = 'none';
      document.getElementById('soff-result-tip').textContent =
        'Calçados de couro tendem a ceder com o uso. Se estiver na dúvida entre dois números, opte pelo maior.';
    } else {
      const res = recomendar(estado.altura, estado.peso, estado.tipo, estado.fit);
      estado.resultado = res.tamanho;
      const fitLabel = estado.fit === 'justa' ? ' · caimento justo' : estado.fit === 'folgada' ? ' · caimento folgado' : '';
      document.getElementById('soff-result-eyebrow').textContent = 'Tamanho recomendado';
      document.getElementById('soff-result-size').textContent = res.tamanho;
      document.getElementById('soff-result-sub').textContent =
        (estado.tipo === 'bottom' ? 'parte de baixo' : 'parte de cima') + fitLabel;
      shoeRange.style.display = 'none';
      confWrap.style.display = 'flex';
      const tips = {
        'PP': 'Tamanho compacto. Se você tem ombros largos, considere o P.',
        'P':  'Caimento slim. Ideal para quem prefere peças mais ajustadas.',
        'M':  'Nosso tamanho mais versátil. Ótimo caimento para a maioria.',
        'G':  'Caimento confortável com boa amplitude nos ombros.',
        'GG': 'Corte generoso. Os tecidos premium caem muito bem.',
        'XG': 'Tamanho plus com silhueta elegante.',
        '2XG':'Modelagem ampla sem abrir mão do caimento.',
        '3XG':'Conforto e estilo com acabamento impecável.',
        '4XG':'Em dúvida? Fale conosco pelo WhatsApp antes de comprar.',
      };
      document.getElementById('soff-result-tip').textContent = tips[res.tamanho] || '';
      setTimeout(() => {
        document.getElementById('soff-conf-bar').style.width = res.confianca + '%';
        document.getElementById('soff-conf-pct').textContent = res.confianca + '%';
      }, 120);
    }

    soffTrack('size_guide_completed', { tipo: estado.tipo, tamanho: estado.resultado, fit: estado.fit || null });
    mostrarStep('resultado');
    try {
      localStorage.setItem('soff_medidas', JSON.stringify({
        altura: estado.altura, peso: estado.peso, tipo: estado.tipo, fit: estado.fit, pe: estado.pe
      }));
    } catch(e) {}
  }

  // ─── APLICAR TAMANHO ─────────────────────────────────────────────────────
  function aplicarTamanho(tamanho) {
    let aplicado = false;
    document.querySelectorAll('input[type="radio"]').forEach(el => {
      if (el.value === tamanho || el.getAttribute('data-value') === tamanho) {
        el.click(); aplicado = true;
      }
    });
    if (!aplicado) {
      document.querySelectorAll('select').forEach(sel => {
        Array.from(sel.options).forEach(opt => {
          if (opt.value === tamanho || opt.text.trim() === tamanho) {
            sel.value = opt.value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            aplicado = true;
          }
        });
      });
    }
    if (!aplicado) {
      document.querySelectorAll('button, .swatch-element label, .variant-input').forEach(el => {
        if (el.textContent.trim() === tamanho) { el.click(); aplicado = true; }
      });
    }
    soffTrack('size_guide_applied', { tipo: estado.tipo, tamanho: tamanho, aplicado_automaticamente: aplicado });
    fecharModal();
    const toast = document.createElement('div');
    toast.className = 'soff-toast';
    toast.textContent = aplicado
      ? (estado.tipo === 'shoe' ? `Número ${tamanho} selecionado ✓` : `Tamanho ${tamanho} selecionado ✓`)
      : `Seu tamanho é ${tamanho}. Selecione manualmente.`;
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 3000);
  }

  // ─── GA4 TRACKING ───────────────────────────────────────────────────────
  function soffTrack(eventName, params) {
    try {
      if (typeof gtag === 'function') {
        gtag('event', eventName, params || {});
      }
    } catch(e) {}
  }

  function abrirModal() {
    try {
      const salvo = JSON.parse(localStorage.getItem('soff_medidas') || 'null');
      if (salvo) {
        if (salvo.altura) { estado.altura = salvo.altura; document.getElementById('soff-slider-altura').value = salvo.altura; document.getElementById('soff-altura-val').textContent = salvo.altura; }
        if (salvo.peso)   { estado.peso = salvo.peso;     document.getElementById('soff-slider-peso').value = salvo.peso;   document.getElementById('soff-peso-val').textContent = salvo.peso; }
        if (salvo.pe)     { estado.pe = salvo.pe;         document.getElementById('soff-slider-pe').value = salvo.pe;       document.getElementById('soff-pe-val').textContent = (salvo.pe / 10).toFixed(1); }
        if (salvo.fit)    { estado.fit = salvo.fit; document.querySelectorAll('.soff-fit-btn').forEach(b => { b.classList.toggle('selected', b.dataset.fit === salvo.fit); }); }
      }
    } catch(e) { console.warn('soff localStorage:', e); }
    try {
      // Reset conf bar
      document.getElementById('soff-conf-bar').style.width = '0%';
      document.getElementById('soff-conf-pct').textContent = '—';
      document.getElementById('soff-dot-4').style.display = '';
      document.getElementById('soff-overlay').classList.add('open');
      soffTrack('size_guide_opened', { page: window.location.pathname });
      document.body.style.overflow = 'hidden';
      // Reset tipo
      estado.tipo = null;
      document.querySelectorAll('.soff-type-card').forEach(c => c.classList.remove('selected'));
      document.getElementById('soff-btn-1').disabled = true;
      mostrarStep('1');
    } catch(e) { console.error('SOFF abrirModal error:', e.message, e.stack); }
  }

  function fecharModal() {
    document.getElementById('soff-overlay').classList.remove('open');
    document.body.style.overflow = '';
  }

  // ─── INIT ────────────────────────────────────────────────────────────────
  function init() {
    const style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);
    document.body.insertAdjacentHTML('beforeend', criarHTML());

    // ── Só exibe em páginas com seletor de tamanho real ──
    const temSeletorTamanho = !!(
      document.querySelector('input[name="Size"], input[name="Tamanho"], input[name="tamanho"], select[name="Size"], select[name="Tamanho"], [data-option="Size"], [data-option="Tamanho"]')
    );
    const todosLabels = document.querySelectorAll('label');
    let labelTamanho = null;
    todosLabels.forEach(lbl => {
      const txt = lbl.textContent.toLowerCase();
      if ((txt.includes('tamanho') || txt.includes('size') || txt.includes('tam.')) && !labelTamanho) {
        labelTamanho = lbl;
      }
    });
    // Aborta se não houver nem label nem input de tamanho
    if (!temSeletorTamanho && !labelTamanho) return;

    // ── Botão trigger ──
    const btnTrigger = document.createElement('button');
    btnTrigger.id = 'soff-size-btn';
    btnTrigger.type = 'button'; // impede submit acidental do form
    btnTrigger.innerHTML = ICON_RULER + ' Qual é o meu tamanho?';

    let inserido = false;
    if (labelTamanho) { labelTamanho.insertAdjacentElement('afterend', btnTrigger); inserido = true; }

    if (!inserido && temSeletorTamanho) {
      const inputs = document.querySelectorAll('input[name="Size"], input[name="Tamanho"], input[name="tamanho"], select[name="Size"], select[name="Tamanho"]');
      if (inputs.length) {
        const pai = inputs[0].closest('fieldset, .product-form__input, [class*="variant"], [class*="option"], form') || inputs[0].parentElement;
        if (pai) { pai.insertBefore(btnTrigger, pai.firstChild); inserido = true; }
      }
    }
    if (!inserido) return;

    // ── Logo: copia do header se existir ──
    const logoWrap = document.getElementById('soff-logo-wrap');
    const headerLogo = document.querySelector('header img, .header__heading-logo, .site-header__logo-image, img[class*="logo"]');
    if (headerLogo && logoWrap) {
      const logoClone = headerLogo.cloneNode(true);
      logoClone.removeAttribute('id');
      logoClone.style.cssText = '';
      logoWrap.appendChild(logoClone);
    } else if (logoWrap) {
      logoWrap.innerHTML = '<span class="soff-brand-text">Soffisticata</span>';
    }

    btnTrigger.addEventListener('click', abrirModal);
    bindEvents();
  }

  function bindEvents() {
    document.getElementById('soff-modal-close').addEventListener('click', fecharModal);
    document.getElementById('soff-overlay').addEventListener('click', e => {
      if (e.target === document.getElementById('soff-overlay')) fecharModal();
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') fecharModal(); });

    // Tipo
    document.querySelectorAll('.soff-type-card').forEach(card => {
      card.addEventListener('click', () => {
        document.querySelectorAll('.soff-type-card').forEach(c => c.classList.remove('selected'));
        card.classList.add('selected');
        estado.tipo = card.dataset.type;
        document.getElementById('soff-btn-1').disabled = false;
      });
    });
    document.getElementById('soff-btn-1').addEventListener('click', () => {
      if (estado.tipo === 'shoe') mostrarStep('2b');
      else mostrarStep('2a');
    });

    // Fit
    document.querySelectorAll('.soff-fit-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.soff-fit-btn').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        estado.fit = btn.dataset.fit;
        localStorage.setItem('soff_medidas', JSON.stringify({ altura: estado.altura, peso: estado.peso, pe: estado.pe, fit: estado.fit }));
      });
    });
    document.getElementById('soff-btn-2a').addEventListener('click', () => mostrarStep('3'));
    document.getElementById('soff-back-2a').addEventListener('click', () => mostrarStep('1'));

    // Calçado
    document.getElementById('soff-slider-pe').addEventListener('input', () => {
      estado.pe = +document.getElementById('soff-slider-pe').value;
      document.getElementById('soff-pe-val').textContent = (estado.pe / 10).toFixed(1);
      localStorage.setItem('soff_medidas', JSON.stringify({ altura: estado.altura, peso: estado.peso, pe: estado.pe, fit: estado.fit }));
    });
    document.getElementById('soff-btn-2b').addEventListener('click', () => { calcTamanho(); mostrarStep('resultado'); });
    document.getElementById('soff-back-2b').addEventListener('click', () => mostrarStep('1'));

    // Altura
    document.getElementById('soff-slider-altura').addEventListener('input', () => {
      estado.altura = +document.getElementById('soff-slider-altura').value;
      document.getElementById('soff-altura-val').textContent = estado.altura;
      localStorage.setItem('soff_medidas', JSON.stringify({ altura: estado.altura, peso: estado.peso, pe: estado.pe, fit: estado.fit }));
    });
    document.getElementById('soff-btn-3').addEventListener('click', () => mostrarStep('4'));
    document.getElementById('soff-back-3').addEventListener('click', () => mostrarStep('2a'));

    // Peso
    document.getElementById('soff-slider-peso').addEventListener('input', () => {
      estado.peso = +document.getElementById('soff-slider-peso').value;
      document.getElementById('soff-peso-val').textContent = estado.peso;
      localStorage.setItem('soff_medidas', JSON.stringify({ altura: estado.altura, peso: estado.peso, pe: estado.pe, fit: estado.fit }));
    });
    document.getElementById('soff-btn-4').addEventListener('click', () => { calcTamanho(); mostrarStep('resultado'); });
    document.getElementById('soff-back-4').addEventListener('click', () => mostrarStep('3'));

    // Resultado
    document.getElementById('soff-btn-apply').addEventListener('click', () => aplicarTamanho(estado.resultado));
    document.getElementById('soff-retry').addEventListener('click', () => {
      document.getElementById('soff-dot-4').style.display = '';
      mostrarStep('1');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})(window, document);